import axios, { getAuthHeaders } from "./config";
export default {
    store: function(group) {
        return axios.post("/groups", group, {
            headers: getAuthHeaders(),
        });
    },
    addUserToGroup: function (data) {
        return axios.post(`/users-groups/`, data, {
            headers: getAuthHeaders(),
        });
    },
    deleteUserFromGroup: function (data) {
        return axios.post(`/del-user-group/`, data, {
            headers: getAuthHeaders(),
        });
    },
    get: function() {
        return axios.get('/groups', {
            headers: getAuthHeaders(),
        });
    },
    show: function(groupID) {
        return axios.get(`/groups/${groupID}`, {
            headers: getAuthHeaders(),
        });
    },
    update: function(data) {
        return axios.put(`/groups/${data.id}`, data, {
            headers: getAuthHeaders(),
        });
    },
    delete: function(groupID) {
        return axios.delete(`/groups/${groupID}`, {
            headers: getAuthHeaders(),
        });
    },
}